import React from "react";
import "./Blue_btn.css";
import { Button } from "react-bootstrap";

// function Blue_btn({ btn_text, onClick }) {
//   return (
//     <>
//       <section className="Blue_btn_holder">
//         <Button className="blue_btn" type="button" onClick={onClick}>
//           {btn_text}
//         </Button>
//       </section>
//     </>
//   );
// }

// export default Blue_btn;

function Blue_btn({ btn_text, onClick, type = "button" }) {
  return (
    <section className="Blue_btn_holder">
      <Button className="blue_btn" type={type} onClick={onClick}>
        {btn_text}
      </Button>
    </section>
  );
}

export default Blue_btn;
